import React, { useEffect, useState, useRef } from 'react';
import './StatsSection.css';

const stats = [
  { icon: '📅', value: 10, label: 'Years Experience', suffix: '+' },
  { icon: '🚀', value: 1000, label: 'Projects Done', suffix: '+' },
  { icon: '⭐', value: 200, label: 'Happy Clients', suffix: '+' },
  { icon: '👥', value: 25, label: 'Expert Members', suffix: '+' },
];

const StatsSection = () => {
  const [counts, setCounts] = useState(stats.map(() => 0));
  const [isVisible, setIsVisible] = useState(false);
  const observerRef = useRef(null);
  const hasStarted = useRef(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasStarted.current) {
          setIsVisible(true);
          hasStarted.current = true;
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observerRef.current.observe(sectionRef.current);
    return () => observerRef.current.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    const duration = 2000;
    const intervals = stats.map((stat, index) => {
      const step = stat.value / (duration / 50);
      return setInterval(() => {
        setCounts((prevCounts) => {
          const newCounts = [...prevCounts];
          if (newCounts[index] < stat.value) {
            newCounts[index] = Math.min(newCounts[index] + step, stat.value);
          }
          return newCounts;
        });
      }, 50);
    });

    setTimeout(() => {
      intervals.forEach(clearInterval);
      setCounts(stats.map((stat) => stat.value));
    }, duration);

    return () => intervals.forEach(clearInterval);
  }, [isVisible]);

  return (
    <section className="snow-stats" ref={sectionRef} id="stats">
      <div className="snow-stats-inner">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="snow-stat-card"
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <div className="snow-stat-icon">{stat.icon}</div>
            <div className="snow-stat-value">
              {Math.round(counts[index])}{stat.suffix}
            </div>
            <div className="snow-stat-label">{stat.label}</div>
            <div className="snow-stat-frost"></div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsSection;
